import React, { useContext } from 'react'
import { Divider, useMediaQuery, InputAdornment, IconButton } from '@material-ui/core'
import FlexView from 'react-flexview/lib';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import EventIcon from '@material-ui/icons/Event';
import { DateTimePicker } from "@material-ui/pickers";
import { BlueGrayBox } from '../Core/BlueGrayBox';
import { useForm, Controller } from 'react-hook-form';
import { ClaimContextStore } from '../../context/ClaimContext';
import { ActivePoliciesList } from '../PolicyManagement/ActivePolicies/ActivePoliciesList';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { BackButton } from '../Core/Buttons/BackButton';
import dayjs from 'dayjs';
import { PolicyCardSkeleton } from '../PolicyManagement/PolicyCardSkeleton';
import { PoliciesSelectionGrid } from '../PolicyManagement/PoliciesSelectionGrid';



export const ClaimSelectPolicy = () => {
    const claimContext = useContext(ClaimContextStore)
    const isMobileByWidth = !useMediaQuery(theme => theme.breakpoints.up('md'));
    const { register, getValues, triggerValidation, control, errors, watch } = useForm({defaultValues: {'claim_date_happen': claimContext.date_happen}})
    const incidentDateWatch = watch('claim_date_happen', claimContext.date_happen)
    const [policies, setPolicies] = React.useState([])

    const onPolicySelect = (policy, index) => {
        claimContext.setSelectedPolicy(policy, getValues()['claim_date_happen'])
        EventEmitterService.dispatch(EventKey.CLAIM_POLICY_SELECTED)
    }

    React.useEffect(() => {
        if(incidentDateWatch)
            setPolicies(claimContext.all_policies.filter(ins => dayjs(ins._insuranceStart).isBefore(incidentDateWatch) && dayjs(incidentDateWatch).isBefore(ins.insuranceEnd)))

    }, [claimContext.all_policies, incidentDateWatch])


    return (<>
        <br />
        <div className="text-title blue bold">Select Policy</div>
        {!isMobileByWidth && <Divider />}
        <div className="text-body gray margin-top-6">When did the incident happen?</div>
        <FlexView>
            <BlueGrayBox className="margin-top-basic">
             <Controller 
                name="claim_date_happen"
                control={control}
                as={<DateTimePicker
                        id="claim_date_btn"
                        maxDate={new Date()}
                        disableFuture
                        error={!!errors.claim_date_happen}
                        className="clickable"
                        format={FirebaseService.getValue(FirebaseConfigKey.DATE_TIME_FORMAT)}
                        InputProps={{ disableUnderline: true, className: 'lightgrayblue', endAdornment: <InputAdornment>
                            <IconButton className="lightgrayblue">
                                <EventIcon fontSize={'small'} className="lightgrayblue" />
                            </IconButton>
                        </InputAdornment> }} />} />    
            </BlueGrayBox>
        </FlexView>
        <br />
        {incidentDateWatch && <> 
            <div className="text-body gray margin-top-basic">Select the relevant policy during that time</div>

            {claimContext.loading_policies ?
                <PolicyCardSkeleton /> 
                :
                <PoliciesSelectionGrid 
                    onPolicySelect={onPolicySelect}
                    policies={policies} 
                    />}
                    

            <br />
            <br />
        </>}
        <BackButton />
    </>)
}